import { clsx } from 'clsx';
import { LCC_CONSTANTS } from '@lcc/shared';

interface Props {
  bookings: number;
  ceiling?: number;
}

export function CapacityBar({ bookings, ceiling = LCC_CONSTANTS.CAPACITY_JOBS_PER_WEEK }: Props) {
  const pct = Math.min(bookings / ceiling, 1);
  const pctDisplay = Math.round(pct * 100);

  return (
    <div>
      <div className="flex justify-between items-baseline mb-1">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Capacity</span>
        <span className="font-mono text-sm font-medium text-navy">
          {bookings}/{ceiling} jobs
        </span>
      </div>
      <div className="h-2.5 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={clsx(
            'h-full rounded-full transition-all duration-500',
            pct >= LCC_CONSTANTS.CAPACITY_CRITICAL_PCT && 'bg-red-500',
            pct >= LCC_CONSTANTS.CAPACITY_WARNING_PCT && pct < LCC_CONSTANTS.CAPACITY_CRITICAL_PCT && 'bg-amber-500',
            pct < LCC_CONSTANTS.CAPACITY_WARNING_PCT && 'bg-[#4A7C2A]'
          )}
          style={{ width: `${pctDisplay}%` }}
        />
      </div>
      <p className="mt-1 text-xs text-gray-400">{pctDisplay}% this week</p>
    </div>
  );
}
